import api from "@/api/api-v2-config";

export async function getProjectCostByIdAxios(projectCostId) {
  return await api.get(`projectmanagements/projectcostlist`, {
    params: { ProjectId: projectCostId }, // Ensure query parameter is passed correctly
  });
}

export async function createProjectCostAxios(data) {
  return await api.post("projectmanagements/projectcost", data);
}

export async function updateProjectCostAxios(data) {
  return await api.put("projectmanagements/projectcost", data);
}

export async function deleteProjectCostAxios(projectCostId) {
  return await api.delete(`projectmanagements/projectcost`,{
    params: { ProjectCostId: projectCostId },
  });
}
